export default __webpack_public_path__ + "static/media/activeM2.19519752.svg";